module.exports = __webpack_public_path__ + "media/images/icon_login_02-dae87257ca3257ac13ef035ab9f06ebd.svg";